import React from 'react';
import { Check } from '@phosphor-icons/react';

/** Scelta multipla delle professioni offerte (chip selezionabili). */
export const ProfessionChips = ({ professions, value, onChange, locked = [], testPrefix = 'offered' }) => (
  <div className="flex flex-wrap gap-2" data-testid={`${testPrefix}-professions`}>
    {professions.map((p) => {
      const fromStaff = locked.includes(p.code);
      const on = fromStaff || value.includes(p.code);
      return (
        <button key={p.code} type="button" disabled={fromStaff}
          onClick={() => onChange(on ? value.filter((c) => c !== p.code) : [...value, p.code])}
          title={fromStaff ? 'Coperta dal tuo organico' : undefined}
          className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs border transition-colors ${on ? 'bg-primary text-primary-foreground border-primary' : 'bg-background border-border hover:border-primary'} ${fromStaff ? 'opacity-70 cursor-default' : ''}`}
          data-testid={`${testPrefix}-prof-${p.code}`}>
          {on && <Check size={12} weight="bold" />}{p.label}{fromStaff && ' · organico'}
        </button>
      );
    })}
  </div>
);

export default ProfessionChips;
